import Fallback from "app/components/Fallback";
import { Suspense, lazy } from "react";

const ErpCollection = lazy(() =>
  import("app/modules/collection/pages/ErpCollection")
);
const TaxInvoice = lazy(() =>
  import("app/modules/collection/pages/TaxInvoice")
);
const DueFollowUp = lazy(() =>
  import("app/modules/collection/pages/DueFollowUp")
);
export const ErpCollectionPage = (props) => (
  <Suspense fallback={<Fallback />}>
    <ErpCollection {...props} />
  </Suspense>
);
export const TaxInvoicePage = (props) => (
  <Suspense fallback={<Fallback />}>
    <TaxInvoice {...props} />
  </Suspense>
);

export const DueFollowUpPage = (prop) =>(
  <Suspense fallback={<Fallback />}>
    <DueFollowUp {...prop} />
  </Suspense>
)